export default "/images/3ec912f367e5cbea10a64911372d7b50.jpg";